import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { MapCableDataPoint } from '@/server/MakeSenseApp-backend'
import { ref, PropType } from 'vue'

const strokeColor = '#00215F'


export default /*@__PURE__*/_defineComponent({
  __name: 'Cable',
  props: {
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {

const strokeWidth = ref(12)


return (_ctx: any,_cache: any) => {
  const _component_ol_geom_line_string = _resolveComponent("ol-geom-line-string")!
  const _component_ol_style_stroke = _resolveComponent("ol-style-stroke")!
  const _component_ol_style = _resolveComponent("ol-style")!
  const _component_ol_feature = _resolveComponent("ol-feature")!
  const _component_ol_source_vector = _resolveComponent("ol-source-vector")!
  const _component_ol_vector_layer = _resolveComponent("ol-vector-layer")!

  return (_openBlock(), _createBlock(_component_ol_vector_layer, {
    zIndex: "10",
    visible: __props.isVisible
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ol_source_vector, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sensorReadings.slice(0, -1), (sensor, index) => {
            return (_openBlock(), _createBlock(_component_ol_feature, {
              key: index,
              properties: { name: index, type: 'cable' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ol_geom_line_string, {
                  coordinates: [
            [__props.sensorReadings[index].coordinate?.easting, __props.sensorReadings[index].coordinate?.northing],
            [
              __props.sensorReadings[index + 1].coordinate?.easting,
              __props.sensorReadings[index + 1].coordinate?.northing
            ]
          ]
                }, null, 8, ["coordinates"]),
                _createVNode(_component_ol_style, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ol_style_stroke, {
                      color: strokeColor,
                      width: strokeWidth.value
                    }, null, 8, ["width"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["properties"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})